<template>
  <div class="python-home">
    <navBarNoLab :onIndex="3" />
    <pythonBackGround :backGroundCom="backGroundComInfo">
      <template #navList>
        <pageElement :onIndex="3" />
      </template>
    </pythonBackGround>
    <!-- 项目专栏 -->
    <manyAspect />
    <!-- 项目课程研发标准 -->
    <developStandard />
    <!-- 多领域职业选择，个人发展快人一步 -->
    <occupatChoice />
    <bottomWidge />
  </div>
</template>

<script>
import navBarNoLab from "@/views/components/navBarNoLab"
import pythonBackGround from "./components/pythonBackGround"
// 多领域职业选择，个人发展快人一步
import occupatChoice from "./components/occupatChoice"
// 项目课程研发标准
import developStandard from "./components/developStandard"
// 多领域多行业覆盖
import manyAspect from "./components/manyAspect"
// demo
import bottomWidge from "@/views/components/bottomWidge"
// 导航抽离
import pageElement from "../common/pageElement"

export default {
  name: "homePython",
  components: {
    navBarNoLab,
    pythonBackGround,
    occupatChoice,
    developStandard,
    manyAspect,
    bottomWidge,
    pageElement
  },
  data () {
    return {
      backGroundComInfo: {
        onIndex: 3,
        title1: "融合开发、测试、部署、运维等一站式服务，使项目研发更加简单高效",
        title: '一站式 ， "全过程"  掌握',
        enTitle: "Ferries to the big data tuyere",
        projectList: [
          {"typeList": "大", "realList": "构建编译"},
          {"typeList": "多", "realList": "自动化测试"},
          {"typeList": "基", "realList": "一键式部署"},
          {"typeList": "企", "realList": "自动化运维"}
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .python-home {
    width: 100%;
    background-color: #fff;
    .topClass {
      position: fixed;
      right: 23px;
      top: 75%;
      background: url("../../../../assets/top.png") no-repeat 50% 50%;
      background-size: 100%;
      display: inline-block;
      width: 50px;
      height: 50px;
      z-index: 999;
      cursor: pointer;
      &:hover {
        background: url("../../../../assets/topon.png") no-repeat 50% 50%;
        background-size: 100%;
      }
    }
  }
</style>